import React from 'react';

import ModalForm from 'components/_global/modal-form/modal-form';
import { activateMultipleCards } from 'actions/cardActions';
import { useDispatch, useSelector } from 'react-redux';
import Label from 'constants/labels';
import { trackCustomEvent } from 'utilities/app-insights';

/**
 * Activate card component
 * 
 * @param cardList - List of cards to activate.
 * @param onClose Close model event
 * @returns JSX Element
 */
const ActivateCard = ({ onClose, cardList }) => {
  const dispatch = useDispatch();

  const readOnly = !useSelector((state) => state.userStore.canReadWriteCards);
  const assignedGrandfatherClientNumber = useSelector((state) => state.userStore.assignedGrandfatherClientNumber);
  const loggedInUser = useSelector((state) => state.userStore.loggedInUser);
  const assignedAccountNumber = useSelector((state) => state.userStore.assignedAccountNumber);
  
  const handleSubmit = () => {
    dispatch(activateMultipleCards(cardList.join(';'), loggedInUser.userId, assignedGrandfatherClientNumber));
    trackCustomEvent('Submit Activate Card', loggedInUser, assignedAccountNumber, 'Clicked Submit button to Activate Card(s).', { selectedCard: cardList });

    onClose();
  };

  return <>
    <ModalForm
      title={Label.ACTIVATE_CARD}
      closeForm={onClose}
      submitClick={handleSubmit}
      inModal={false}
      canSubmit={!readOnly}
    >
      {cardList?.length > 1 ? Label.ACTIVATE_MULTIPLE_CARD_MSG : Label.ACTIVATE_CARD_MSG}
    </ModalForm>
  </>;
};

export default ActivateCard;
